import * as React from "react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"

import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props {
    allSigned: boolean
    onOpenSignatures: () => void
}

export const Signatures = ({
    allSigned,
    onOpenSignatures,
}: Props): JSX.Element => (
    <Action
        onClick={onOpenSignatures}
        actionType={ActionType.icon}
        data-ft-action="open-signatures"
    >
        {Symbols.Signatures}
        {allSigned && <sup>{Symbols.Confirm}</sup>}
    </Action>
)

export default Signatures
